'use_strict';

/**
 * function used to update the protection plan on the frontend
 * @param {Object} $selectedPlanElm - jquery object for selected protection plan
 */
function updateSelectedProtectionPlan($selectedPlanElm) {
    if (typeof $selectedPlanElm !== 'undefined') {
        $('.product-options-protection-plan .main-link')
            .text(
                $selectedPlanElm.attr('data-price') +
					'-' +
					$selectedPlanElm.attr('data-planname')
            )
            .addClass('selected');
    } else {
        $('.product-options-protection-plan .main-link')
            .text('+ Add Protection Plan')
            .removeClass('selected');
    }
}

/**
 * function used to handle engraving prices and selection
 * @param {Object} $productContainer DOM object
 */
function resetProductPriceQuickView($productContainer) {
    // price formatter
    var USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    var $priceSection = $productContainer.find('.modal-footer .prices');
    var $listPriceDOM = $priceSection.find('span.list span');
    var listPrice = $listPriceDOM.attr('content');
    var $salesPriceDom = $priceSection.find('span.sales span');
    var salesPrice = $salesPriceDom.attr('content');
    var price;
    if (typeof listPrice !== 'undefined') {
        // if LP is available on PDP update reset the price
        price = parseFloat(listPrice);
        $listPriceDOM.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }

    if (typeof salesPrice !== 'undefined') {
        // if SP is available on PDP reset the price
        price = parseFloat(salesPrice);
        $salesPriceDom.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }
}

/**
 * function used to handle engraving prices and selection
 * @param {Object} $productContainer DOM object
 */
function resetProductPrice($productContainer) {
    // price formatter
    var USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    var $priceSection = $productContainer.find('.prices-add-to-cart-actions');
    var $listPriceDOM = $priceSection.find('span.list span');
    var listPrice = $listPriceDOM.attr('content');
    var $salesPriceDom = $priceSection.find('span.sales span');
    var salesPrice = $salesPriceDom.attr('content');
    var price;
    if (typeof listPrice !== 'undefined') {
        // if LP is available on PDP update reset the price
        price = parseFloat(listPrice);
        $listPriceDOM.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }

    if (typeof salesPrice !== 'undefined') {
        // if SP is available on PDP reset the price
        price = parseFloat(salesPrice);
        $salesPriceDom.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }
}

/**
 * function used to handle engraving prices and selection
 * @param {Object} $productContainer DOM object
 */
function handleEngravingSelectionQuickView($productContainer) {
    // price formatter
    var USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    var $priceSection = $productContainer.find('.modal-footer .prices');
    var engravingText = $productContainer.find('.js-engraving-text');
    var engravingPrice = $productContainer
        .find('.js-engraving-text')
        .data('engraving-price');
    var pricePerChar = $productContainer
        .find('.js-engraving-text')
        .data('engraving-charge-per-char');
    var $listPriceDOM = $priceSection.find('span.list span');
    var listPrice = $listPriceDOM.attr('content');
    var $salesPriceDom = $priceSection.find('span.sales span');
    var salesPrice = $salesPriceDom.attr('content');
    var price;
    if (typeof listPrice !== 'undefined') {
        // if LP is available on PDP update then with engraving prices
        price = parseFloat(listPrice);
        // adding engraving price
        price += parseFloat(engravingPrice);
        // adding char count price
        price +=
			typeof engravingText !== 'undefined' && engravingText.length
			    ? parseFloat(engravingText.val().length * pricePerChar)
			    : 0;
        $listPriceDOM.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }

    if (typeof salesPrice !== 'undefined') {
        // if SP is available on PDP update then with engraving prices
        // if LP is available on PDP update then with engraving prices
        price = parseFloat(salesPrice);
        // adding engraving price
        price += parseFloat(engravingPrice);
        // adding char count price
        price +=
			typeof engravingText !== 'undefined' && engravingText.length
			    ? parseFloat(engravingText.val().length * pricePerChar)
			    : 0;
        $salesPriceDom.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }
}

/**
 * function used to handle engraving prices and selection
 * @param {Object} $productContainer DOM object
 */
function handleEngravingSelection($productContainer) {
    // price formatter
    var USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    var $priceSection = $productContainer.find('.prices-add-to-cart-actions');
    var engravingText = $productContainer.find('.js-engraving-text');
    var engravingPrice = $productContainer
        .find('.js-engraving-text')
        .data('engraving-price');
    var pricePerChar = $productContainer
        .find('.js-engraving-text')
        .data('engraving-charge-per-char');
    var $listPriceDOM = $priceSection.find('span.list span');
    var listPrice = $listPriceDOM.attr('content');
    var $salesPriceDom = $priceSection.find('span.sales span');
    var salesPrice = $salesPriceDom.attr('content');
    var price;
    if (typeof listPrice !== 'undefined') {
        // if LP is available on PDP update then with engraving prices
        price = parseFloat(listPrice);
        // adding engraving price
        price += parseFloat(engravingPrice);
        // adding char count price
        price +=
			typeof engravingText !== 'undefined' && engravingText.length
			    ? parseFloat(engravingText.val().length * pricePerChar)
			    : 0;
        $listPriceDOM.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }

    if (typeof salesPrice !== 'undefined') {
        // if SP is available on PDP update then with engraving prices
        // if LP is available on PDP update then with engraving prices
        price = parseFloat(salesPrice);
        // adding engraving price
        price += parseFloat(engravingPrice);
        // adding char count price
        price +=
			typeof engravingText !== 'undefined' && engravingText.length
			    ? parseFloat(engravingText.val().length * pricePerChar)
			    : 0;
        $salesPriceDom.html(
            '<span class="sr-only">Price reduced from</span>' +
				USDollar.format(price) +
				'<span class="sr-only">to</span>'
        );
    }
}

module.exports = {
    handleProtectionPlanLogic: function () {
        $(document).on('click', '.js-protection-plan-trigger', function () {
            if ($('.js-protection-plan-trigger:checked').length > 0) {
                $('.js-add-protection-plan').removeAttr('disabled');
            } else {
                $('.js-add-protection-plan').attr('disabled');
            }
        });

        $('input[type="checkbox"].js-protection-plan-trigger').on(
            'click',
            function () {
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                if ($(this).is(':checked')) {
                    var value = $('.js-protection-plan-trigger:checked')[0].value;
                    $productContainer
                        .find('.cart-and-ipay .add-to-cart')
                        .attr('data-protection-plan-sku', value);
                    updateSelectedProtectionPlan($(this));
                } else {
                    $productContainer
                        .find('.cart-and-ipay .add-to-cart')
                        .attr('data-protection-plan-sku', '');
                    updateSelectedProtectionPlan($(this));
                }
            }
        );

        $(document).on('click', '.js-add-protection-plan', function (e) {
            e.preventDefault();
            // check if the call is being done from within the quickview popup
            if ($('.product-quickview').length > 0) {
                var selectedPlan = $('.js-protection-plan-trigger:checked')[0].value;
                $(this)
                    .closest('.product-quickview')
                    .find('.update-cart-product-global, .add-to-cart-global')
                    .attr('data-selected-protection-plan', selectedPlan);
                updateSelectedProtectionPlan($('.js-protection-plan-trigger:checked'));
                $('#protectionPlan').collapse('hide');
            } else {
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                var value = $('.js-protection-plan-trigger:checked')[0].value;
                $productContainer
                    .find('.cart-and-ipay .add-to-cart')
                    .attr('data-protection-plan-sku', value);
                updateSelectedProtectionPlan($('.js-protection-plan-trigger:checked'));
                $('#protectionPlan .close').click();
            }
        });
        $(document).on('click', '.js-remove-protection-plan', function (e) {
            e.preventDefault();
            // check if the call is being done from within the quickview popup
            if ($('.product-quickview').length > 0) {
                $(this)
                    .closest('#editProductModal')
                    .find('.update-cart-product-global')
                    .attr('data-selected-protection-plan', '');
                updateSelectedProtectionPlan();
                $('#protectionPlan').collapse('hide');
            } else {
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                $productContainer
                    .find('.cart-and-ipay .add-to-cart')
                    .attr('data-protection-plan-sku', '');
                updateSelectedProtectionPlan();
                $('#protectionPlan .close').click();
            }
        });
    },
    closeProtectionPlanPopup: function () {
        $(document).on('click', '#protectionPlan .close', function (e) {
            e.preventDefault();
            $('#protectionPlan').modal('toggle');
        });
    },
    handleEngravingAdditiona: function () {
        $(document).on('click', '.js-engrave-item', function (e) {
            e.preventDefault();
            var $productContainer;
            // check if the call is being done from within the quickview popup
            if ($('.product-quickview').length > 0) {
                $productContainer = $(this).closest('.product-quickview');
                $productContainer
                    .find('.js-engraving-form')
                    .attr('data-engraving-selected', true);
                handleEngravingSelectionQuickView($(this).closest('#editProductModal'));
                $('#engraving').collapse('hide');
            } else {
                $productContainer = $(this).closest('.product-detail');
                $productContainer
                    .find('.js-engraving-form')
                    .attr('data-engraving-selected', true);
                handleEngravingSelection($productContainer);
                $('#engraving').modal('toggle');
            }
            $('.js-product-engraving-section .main-link')
                .text('Edit Engraving')
                .addClass('selected');
        });
    },
    handleEngravingRemove: function () {
        $(document).on('click', '.js-engrave-item-cancel', function (e) {
            e.preventDefault();
            var $productContainer = $(this).closest('.product-detail');
            $productContainer
                .find('.js-engraving-form')
                .attr('data-engraving-selected', false);
            // check if the call is being done from within the quickview popup
            if ($('.product-quickview').length > 0) {
                resetProductPriceQuickView($(this).closest('#editProductModal'));
                $('#engraving').collapse('hide');
            } else {
                resetProductPrice($productContainer);
                $('#engraving').modal('toggle');
            }
            $('.js-product-engraving-section .main-link').text('Add Engraving');
        });
    },
    toggleCompare: function () {
        $('.coverage-header').on('click', function () {
            // Remove active class from all headers
            $('.coverage-header').removeClass('active');

            // Add active class to the clicked header
            $(this).addClass('active');

            // Get the data-tab attribute of the clicked header
            const selectedTab = $(this).data('tab');

            // Hide all coverage items
            $('.coverage-item').addClass('mhide');

            // Show only the items that match the selected tab or category items
            $(`.coverage-item.${selectedTab}`).removeClass('mhide');
        });

        // Trigger click on the first tab to initialize
        // $('.coverage-header').first().trigger('click');
    },
    init: function () {
        module.exports.closeProtectionPlanPopup();
        module.exports.handleProtectionPlanLogic();
        module.exports.handleEngravingRemove();
        module.exports.closeProtectionPlanPopup();
        module.exports.handleEngravingAdditiona();
        module.exports.toggleCompare();
    },
};
